'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var missingIt = function missingIt(user, key, id) {
  if (key === 'skills') {
    return !user.skills[id];
  }

  if (user.interests[id]) {
    return user.interests[id].value < 0.5;
  }

  return true;
};

var getMissingThingsString = function getMissingThingsString(things) {
  if (things.length === 1) {
    return things[0];
  }

  return things.slice(0, things.length - 1).join(', ') + ' and ' + things[things.length - 1] + '.';
};

var getReminders = function getReminders(user, constants, data) {
  return ['interests', 'skills'].map(function (key) {
    var missingThings = (0, _objAsArray2.default)(data[key]).filter(function (el) {
      if (el.critical) {
        return missingIt(user, key, el.id);
      }

      return null;
    }).map(function (_ref) {
      var id = _ref.id;

      return data[key][id].label.toLowerCase();
    });

    if (missingThings.length) {
      var missingThingsString = getMissingThingsString(missingThings);
      return '' + constants[key] + missingThingsString;
    }

    return null;
  }).filter(function (el) {
    return el;
  });
};

function mapStateToProps(_ref2) {
  var user = _ref2.user,
      _ref2$ui$keepInMind = _ref2.ui.keepInMind,
      title = _ref2$ui$keepInMind.title,
      description = _ref2$ui$keepInMind.description,
      interests = _ref2$ui$keepInMind.interests,
      skills = _ref2$ui$keepInMind.skills,
      data = _ref2.data;

  var reminders = getReminders(user, {
    interests: interests,
    skills: skills
  }, data);

  return {
    title: title,
    description: description,
    reminders: reminders
  };
}

function mapDispatchToProps() {
  return {};
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/KeepInMind/selectors.js
// module id = 1081
// module chunks = 0